module.exports = (function () {
  'use strict';

  const phxSvgIconDefinition = {
    bindings: {
      className: '@',
      name: '@'
    },
    controller: 'PhxSvgIconController as svg',
    templateUrl: 'ui-ng-svg-icons/src/templates/svg.html'
  };

  angular.module('ui-ng-svg-icons').component('phxSvgIcon', phxSvgIconDefinition);
})();



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-svg-icons/src/core/svg_component.es.js